// ============================================================
// Datei: KaffimobilDesktop.jsx
// ============================================================

import React, { useState } from "react";

import VolunteerList from "../../../components/VolunteerList";
import ShiftTable from "../../../components/shiftTable/ShiftTable";
import EditVolunteerModal from "../../../components/EditVolunteerModal";

import GuestRegistration from "../../../components/GuestRegistration";
import GuestList from "../../../components/guestList/GuestList";
import EditGuestModal from "../../../components/guestList/EditGuestModal";
import DeleteGuestModal from "../../../components/guestList/DeleteGuestModal";
import ShiftPrintList from "../../../components/ShiftPrintList";
import VolunteerPool from "../../../components/VolunteerPool";

import "./kaffimobil.css";

const KaffimobilDesktop = ({
	volunteers,
	setVolunteers,
	shifts,
	guests,
	selectedVolunteer,
	setSelectedVolunteer,
	activeTab,
	setActiveTab,
	reloadGuests,
	reloadVolunteers,
	downloadCcEmails
}) => {
	const [guestToEdit, setGuestToEdit] = useState(null);
	const [guestToDelete, setGuestToDelete] = useState(null);

	const kaffimobil = shifts.filter(
		(s) => s.shiftId >= 121 && s.shiftId <= 128
	);

	const tabs = [
		{ id: "overview", label: "Übersicht" },
		{ id: "helpers", label: "Libellen" },
		{ id: "shifts", label: "Schichtplan" },
//		{ id: "guests", label: "Gästeliste" },
//		{ id: "extras", label: "Extrawürscht" }
	];

	return (
		<div className="kaffimobil-desktop-shell">
			<div className="tabs-container kaffimobil-tabs-container">
				<div className="tab-bar kaffimobil-tab-bar">
					{tabs.map((t) => (
						<button
							key={t.id}
							className={
								"tab-button" +
								(activeTab === t.id ? " tab-button-active" : "")
							}
							onClick={() => setActiveTab(t.id)}
							type="button"
						>
							{t.label}
						</button>
					))}
				</div>

				<div className="tab-panels kaffimobil-tab-panels">

					{activeTab === "helpers" && (
						<div className="helpers-layout">
							<div className="helpers-column helpers-column-left">
								<VolunteerList
									volunteers={volunteers}
									setVolunteers={setVolunteers}
									onEdit={(v) => setSelectedVolunteer(v)}
									reloadVolunteers={reloadVolunteers}
								/>
							</div>

							<div className="helpers-column helpers-column-right">
								<VolunteerPool
									departmentName="Kaffimobil"
									onAssigned={() => {
										if (reloadVolunteers) reloadVolunteers();
									}}
								/>
							</div>
						</div>
					)}

					{activeTab === "shifts" && (
						<div className="kaffimobil-shifts-panel">
							<section className="kaffimobil-shift-section">
								<h3 className="kaffimobil-subheading">Kaffimobil</h3>
								<ShiftTable shifts={kaffimobil} />
							</section>
						</div>
					)}

				{activeTab === "guests" && (
						<div className="kaffimobil-guests-panel">
							<GuestRegistration refreshGuestList={reloadGuests} />
							<GuestList
								guests={guests}
								onEdit={(g) => setGuestToEdit(g)}
								onDelete={(g) => setGuestToDelete(g)}
							/>
						</div>
					)}

				{activeTab === "extras" && (
						<div className="kaffimobil-extras-panel">
							<button
								className="cc-mail-card"
								onClick={downloadCcEmails}
								type="button"
							>
								<span className="cc-mail-icon">✉️</span>
								<span className="cc-mail-text">
									<span className="cc-mail-title">
										CC-Liste Helferfest herunterladen
									</span>
									<span className="cc-mail-subtitle">
										Für Outlook &amp; Gmail geeignet
									</span>
								</span>
							</button>
							<ShiftPrintList />
						</div>
					)}
		
				</div>
			</div>

			{selectedVolunteer && (
				<EditVolunteerModal
					volunteer={selectedVolunteer}
					onClose={() => setSelectedVolunteer(null)}
					onSaved={reloadVolunteers}
				/>
			)}

			{guestToEdit && (
				<EditGuestModal
					guest={guestToEdit}
					onClose={() => setGuestToEdit(null)}
					onSaved={() => {
						setGuestToEdit(null);
						reloadGuests();
					}}
				/>
			)}

			{guestToDelete && (
				<DeleteGuestModal
					guest={guestToDelete}
					onClose={() => setGuestToDelete(null)}
					onDeleted={() => {
						setGuestToDelete(null);
						reloadGuests();
					}}
				/>
			)}
		</div>
	);
};

export default KaffimobilDesktop;